import { useState } from 'react';
import { createDispatchHook } from 'react-redux';
import { ReactReduxContext } from 'config/configureStore';
import { appActions } from 'commons/reducer';
import { getItemInStorage } from 'utils/functions';

const useDispatch = createDispatchHook(ReactReduxContext);

const PDF_ERROR_MSG = 'No se pudo generar el PDF. Intente nuevamente en unos segundos.';

const getAuthorizationHeader = () => {
  const session = getItemInStorage('user');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session && session.token}`,
  };
};

// Without this check a failed request was downloaded as a broken PDF file
const fetchPdfBlob = (url, options) =>
  fetch(url, { headers: getAuthorizationHeader(), ...options }).then((response) => {
    if (!response.ok) throw new Error(`PDF request failed with status ${response.status}`);
    return response.blob();
  });

const useQuotePdf = () => {
  const dispatch = useDispatch();
  const [pdf, setPdf] = useState('');
  const [loadingTempPdf, setLoadingTempPdf] = useState(false);
  // Id of the quote whose PDF is being downloaded, null when idle
  const [loadingPdfId, setLoadingPdfId] = useState(null);

  const getTempPdf = (data) => {
    setLoadingTempPdf(true);
    fetchPdfBlob(`/api/v1/quotes/temp-pdf`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then((myBlob) => {
        const reader = new FileReader();
        reader.onload = function () {
          const src = this.result;
          setPdf(src);
          return src;
        };
        reader.readAsDataURL(myBlob);
      })
      .catch(() => dispatch(appActions.setError(PDF_ERROR_MSG)))
      .finally(() => setLoadingTempPdf(false));
  };
  const getPdf = (id) => {
    // Each request launches a Chromium render on the server: avoid stacking them up
    if (loadingPdfId !== null) return;

    setLoadingPdfId(id);
    fetchPdfBlob(`/api/v1/quotes/pdf/${id}`, { method: 'GET' })
      .then((myBlob) => {
        // Download
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(myBlob);
        a.download = `COTIZACION-${id}`;
        a.click();
      })
      .catch(() => dispatch(appActions.setError(PDF_ERROR_MSG)))
      .finally(() => setLoadingPdfId(null));
  };

  const getTempHtml = (data) => {
    fetch(`/api/v1/quotes/temp-html`, {
      method: 'POST',
      headers: getAuthorizationHeader(),
      body: JSON.stringify(data),
    })
      .then((response) => response.text())
      .then((html) => {
        // Abrir en nueva ventana
        const newWindow = window.open();
        newWindow.document.write(html);
        newWindow.document.close();
      });
  };

  return { pdf, loadingTempPdf, loadingPdfId, getTempPdf, getPdf, getTempHtml };
};

export default useQuotePdf;
